// extracted by mini-css-extract-plugin
module.exports = {"card":"card--da20c shadow--6907e"};